// Iron Edge Tools - Industrial Hardware & Power Tools E-commerce
// Brand operator: Fleming Consulting Ventures LLC
// Catalog & product copy sourced from djonesonlinehardware.com

// ============================================
// SITE IMAGES - Hardware / workshop theme (stored locally, brand-free stock)
// ============================================
export const siteImages = {
  heroMain: '/banners/hero.jpg',
  heroSecondary: '/banners/promo.jpg',
  heroLifestyle: '/banners/about.jpg',
  ctaBackground: '/banners/cta.jpg',
  featuredBackground: '/banners/cta.jpg',
  powerBackground: '/banners/promo.jpg',
  shopBanner: '/banners/shop.jpg',
  aboutBanner: '/banners/about.jpg',
  contactBanner: '/banners/contact.jpg',
  returnsBanner: '/banners/shop.jpg',
  privacyBanner: '/banners/about.jpg',
};

export const SHIPPING_NOTICE = 'Free USPS shipping across the United States';
export const SHIPPING_COUNTRIES = ['US'];
export const SHIPPING_METHOD = 'USPS';
export const SHIPPING_TIME = '2-4 business days';
export const FREE_SHIPPING_THRESHOLD = 0; // Free shipping on all orders

export const CARD_DESCRIPTOR = '8669385494ironedgetools';
export const HOSTING_PROVIDER = 'Hostinger';

export const CONTACT_INFO = {
  phone: '(866) 938-5494',
  email: 'support@ironedgetools.com',
  corpName: 'Fleming Consulting Ventures LLC',
  address: {
    street: '228 Park Ave S #820210',
    city: 'New York',
    state: 'NY',
    zip: '10003',
    country: 'United States'
  }
};

// Return address must remain unchanged.
export const RETURN_ADDRESS = {
  street: '4711 34th St. N. Suite F',
  city: 'St. Petersburg',
  state: 'FL',
  zip: '33714',
  country: 'USA'
};

// ============================================
// HARDWARE & POWER TOOLS CATALOG (14 Products)
// Prices fixed to required processor MID points:
//   $9.63, $12.84, $19.26, $19.37, $28.89, $58.11, $77.48,
//   $142.16, $227.48, $318.72, $489.36, $612.44, $784.88, $999.00
// Product names, images and descriptions sourced from djonesonlinehardware.com
// ============================================
export const products = [
  // ===== MEASURING & DETECTION =====
  {
    id: "laser-range-finder",
    name: "Laser Range Finder",
    slug: "laser-range-finder",
    sku: "IET-MSR-001",
    price: 9.63,
    image: "/products/tools/laser-range-finder.jpg",
    badge: "Deal",
    categoryId: "measuring-detection",
    categorySlug: "measuring-detection",
    description: "This compact and easy-to-use device accurately measures distances up to 100 feet using laser technology. It's perfect for DIY projects, home renovations, and construction tasks. The digital display provides clear and precise measurements, making it a handy tool for any toolbox.",
    keyBenefits: ["Measures distances up to 100 feet", "Clear digital measurement display", "Pocket-sized for any toolbox"],
    usage: "Point it at your target, press the button and read the precise distance on the digital display.",
    features: ["Laser Tech", "Digital Display", "Up to 100 ft", "Compact"],
    inStock: true
  },
  {
    id: "magnetic-stud-finder",
    name: "Magnetic Stud Finder",
    slug: "magnetic-stud-finder",
    sku: "IET-MSR-002",
    price: 12.84,
    image: "/products/tools/magnetic-stud-finder.jpg",
    badge: "Best Value",
    categoryId: "measuring-detection",
    categorySlug: "measuring-detection",
    description: "Locate studs, metal pipes, and live electrical wires behind walls with this versatile stud finder. It features multiple scanning modes for different materials and depths, ensuring accurate detection every time. The ergonomic design and easy-to-read display make it suitable for both professionals and DIY enthusiasts.",
    keyBenefits: ["Detects studs, metal and live wires", "Multiple scanning modes", "Ergonomic, easy-read display"],
    usage: "Select a scan mode, glide it across the wall and mark the spots it flags before you drill.",
    features: ["Multi-Mode", "Wire Detect", "Ergonomic", "Easy-Read"],
    inStock: true
  },
  {
    id: "voltage-tester",
    name: "Advanced Waterproof Voltage Tester",
    slug: "advanced-waterproof-voltage-tester",
    sku: "IET-MSR-003",
    price: 77.48,
    image: "/products/tools/voltage-tester.jpg",
    badge: "Pro Pick",
    categoryId: "measuring-detection",
    categorySlug: "measuring-detection",
    description: "Safely identify live circuits in wet or dusty conditions with this IP67-rated voltage tester. A bright LED indicator and audible alarm give you instant confirmation without needing to read a tiny screen in dim spaces. Non-contact detection covers 12V to 1000V AC, with a built-in tip flashlight and a CAT IV 1000V safety rating for industrial environments.",
    keyBenefits: ["IP67 waterproof and dustproof", "12V-1000V non-contact detection", "CAT IV 1000V safety rated"],
    usage: "Hold the tip near a wire or outlet and watch for the LED and alarm to confirm live voltage.",
    features: ["IP67", "Non-Contact", "LED + Alarm", "CAT IV"],
    inStock: true
  },
  {
    id: "clamp-meter-kit",
    name: "Precision Digital Clamp Meter Kit",
    slug: "precision-digital-clamp-meter-kit",
    sku: "IET-MSR-004",
    price: 227.48,
    image: "/products/tools/clamp-meter-kit.jpg",
    badge: "Popular",
    categoryId: "measuring-detection",
    categorySlug: "measuring-detection",
    description: "This Precision Digital Clamp Meter Kit is a comprehensive solution for professional electricians and hobbyists needing accurate electrical measurements. The kit includes a high-performance digital clamp meter capable of reading AC/DC voltage, current, resistance, and continuity. It features a large, easy-to-read display and a robust clamp for non-invasive current measurement in tight spaces, plus a carrying case for the meter, test leads, and manual.",
    keyBenefits: ["AC/DC voltage, current and resistance", "Non-contact clamp measurement", "Backlit LCD with carry case"],
    usage: "Clamp around a conductor or touch the leads, select the mode and read the value on the LCD.",
    features: ["Clamp", "Auto-Range", "Backlit LCD", "Kit Case"],
    inStock: true
  },

  // ===== HAND TOOLS =====
  {
    id: "pipe-wrench",
    name: "Multifunction Auto Pipe Wrench",
    slug: "multifunction-auto-pipe-wrench",
    sku: "IET-HND-001",
    price: 19.26,
    image: "/products/tools/pipe-wrench.jpg",
    badge: "Best Seller",
    categoryId: "hand-tools",
    categorySlug: "hand-tools",
    description: "Unleash the power of convenience and efficiency with our Multifunction Auto Power Grip Pipe Wrench - a must-have tool for every DIY enthusiast and professional plumber. Designed for a seamless grip and turn of pipes, nuts, and bolts, the innovative auto-adjusting technology allows for one-hand operation, while anti-slip handles and hardened steel construction deliver comfort and long-lasting performance.",
    keyBenefits: ["Auto-adjusting one-hand grip", "Hardened steel construction", "Two sizes included"],
    usage: "Clamp the jaws onto the pipe or nut, let the auto-grip lock on and turn.",
    features: ["Auto-Grip", "Hardened Steel", "Anti-Slip", "2 Sizes"],
    inStock: true
  },
  {
    id: "torque-wrench-set",
    name: "Precision Torque Wrench Set",
    slug: "precision-torque-wrench-set",
    sku: "IET-HND-002",
    price: 28.89,
    image: "/products/tools/torque-wrench-set.jpg",
    badge: "New",
    categoryId: "hand-tools",
    categorySlug: "hand-tools",
    description: "Three-piece precision torque wrench set with 1/4 in, 3/8 in, and 1/2 in drives, delivering accurate, repeatable torque for automotive and mechanical work. Each click-type wrench offers an easy-to-set dual-range scale and reverses for loosening, and the set stores in a rugged blow-molded case.",
    keyBenefits: ["1/4\", 3/8\" and 1/2\" drives", "Accurate click-type calibration", "Rugged blow-molded case"],
    usage: "Dial in your target torque, tighten until the wrench clicks and store it in the case.",
    features: ["3 Drives", "Click-Type", "Reversible", "Cased"],
    inStock: true
  },
  {
    id: "screwdriver-set",
    name: "180-in-1 Precision Electric Screwdriver Set",
    slug: "180-in-1-precision-electric-screwdriver-set",
    sku: "IET-HND-003",
    price: 58.11,
    image: "/products/tools/screwdriver-set.jpg",
    badge: "Popular",
    categoryId: "hand-tools",
    categorySlug: "hand-tools",
    description: "Tackle electronics repairs, furniture assembly, and intricate hardware projects with this comprehensive electric screwdriver kit. 180 precision bits cover virtually every fastener type you will encounter, all driven by a cordless power handle with adjustable torque, a magnetic quick-change holder, a built-in LED work light, and USB-C recharging.",
    keyBenefits: ["180 precision CRV steel bits", "Cordless powered handle", "LED work light and USB-C charging"],
    usage: "Snap in the bit you need, set the torque and let the powered handle drive it home.",
    features: ["180 Bits", "Cordless", "LED Light", "USB-C"],
    inStock: true
  },

  // ===== POWER TOOLS =====
  {
    id: "cordless-drill-set",
    name: "Compact Cordless Drill Set with Accessories",
    slug: "compact-cordless-drill-set-with-accessories",
    sku: "IET-PWR-001",
    price: 142.16,
    image: "/products/tools/cordless-drill-set.jpg",
    badge: "Best Seller",
    categoryId: "power-tools",
    categorySlug: "power-tools",
    description: "The Compact Cordless Drill Set is a versatile and essential tool kit for any home improvement enthusiast or professional. This comprehensive set includes a powerful cordless drill, multiple drill bits, screwdriver bits, and essential attachments, all neatly organized in a sturdy carrying case. The drill features a robust motor, variable speed control, and a comfortable grip handle that makes it easy to handle for various drilling and driving tasks.",
    keyBenefits: ["Powerful variable-speed drill", "Drill and driver bits included", "Sturdy carrying case"],
    usage: "Charge the battery, choose your bit and speed, and drill or drive with a comfortable grip.",
    features: ["Cordless", "Variable Speed", "Bit Set", "Cased"],
    inStock: true
  },
  {
    id: "angle-grinder",
    name: "Professional Cordless Angle Grinder",
    slug: "professional-cordless-angle-grinder",
    sku: "IET-PWR-002",
    price: 318.72,
    image: "/products/tools/angle-grinder.jpg",
    badge: "Editor's Choice",
    categoryId: "power-tools",
    categorySlug: "power-tools",
    description: "The Professional Cordless Angle Grinder is a powerful and versatile tool designed for cutting, grinding, and polishing applications in metalworking, construction, and emergency rescues. This high-performance tool features a robust motor that delivers maximum power and durability without the hassle of cords, offering greater mobility and ease of use at any job site. It includes an adjustable guard to ensure safety and control over every job. Please note that this model does not include a battery, which must be purchased separately.",
    keyBenefits: ["Cordless cutting and grinding", "High-performance motor", "Adjustable safety guard"],
    usage: "Fit the disc, position the guard and squeeze the trigger to cut, grind or polish (battery sold separately).",
    features: ["Cordless", "High-Power", "Safety Guard", "Durable"],
    inStock: true
  },
  {
    id: "jigsaw",
    name: "Jigsaw",
    slug: "jigsaw",
    sku: "IET-PWR-003",
    price: 489.36,
    image: "/products/tools/jigsaw.jpg",
    badge: "Premium",
    categoryId: "power-tools",
    categorySlug: "power-tools",
    description: "Make precision cuts with ease using our electric jigsaw - the ultimate power tool for your cutting needs, from intricate curves to straight lines. A built-in laser guide enhances accuracy, variable speed control tailors performance to each material, and an ergonomic soft-grip handle reduces vibration so you can cut through wood, metal, or plastic cleanly and comfortably.",
    keyBenefits: ["Laser guide for accuracy", "Variable speed control", "Cuts wood, metal and plastic"],
    usage: "Follow the laser line, set the speed for your material and guide the blade through the cut.",
    features: ["Laser Guide", "Variable Speed", "Ergonomic", "Versatile"],
    inStock: true
  },

  // ===== WORKSHOP & STORAGE =====
  {
    id: "electrician-waist-bag",
    name: "8-pockets Electrician Waist Bag",
    slug: "8-pockets-electrician-waist-bag",
    sku: "IET-WRK-001",
    price: 19.37,
    image: "/products/tools/electrician-waist-bag.jpg",
    badge: "Deal",
    categoryId: "workshop-storage",
    categorySlug: "workshop-storage",
    description: "Stay organized and efficient with our durable multi-compartment tool bag - the ultimate companion for every handyman. Multiple pockets and sleeves keep your essential tools securely organized and easily accessible, while the reinforced adjustable belt with a quick-release buckle ensures a comfortable, custom fit. Built from heavy-duty canvas with reinforced stitching, it withstands the rigors of daily use.",
    keyBenefits: ["Eight organized pockets", "Quick-release adjustable belt", "Heavy-duty reinforced canvas"],
    usage: "Load your tools into the pockets, cinch the belt to your waist and keep essentials on hand.",
    features: ["8 Pockets", "Adjustable Belt", "Canvas", "Reinforced"],
    inStock: true
  },
  {
    id: "workbench-pegboard",
    name: "Heavy-Duty Workbench with Pegboard",
    slug: "heavy-duty-workbench-with-pegboard",
    sku: "IET-WRK-002",
    price: 612.44,
    image: "/products/tools/workbench-pegboard.jpg",
    badge: "Pro Pick",
    categoryId: "workshop-storage",
    categorySlug: "workshop-storage",
    description: "Combine a rugged work surface with vertical tool organization using this workbench and integrated pegboard combo. Keep your most-used hand tools, tape, and accessories within arm's reach while tackling projects on the reinforced top, complete with a full-width pegboard backwall, a built-in power strip, and a lower storage shelf.",
    keyBenefits: ["Steel-reinforced hardwood top", "Full-width pegboard with 20 hooks", "Built-in power strip and shelf"],
    usage: "Assemble the bench, hang your tools on the pegboard and plug into the built-in power strip.",
    features: ["Reinforced Top", "Pegboard", "Power Strip", "Storage Shelf"],
    inStock: true
  },
  {
    id: "tool-storage-case",
    name: "Rugged Waterproof Tool Storage Case",
    slug: "rugged-waterproof-tool-storage-case",
    sku: "IET-WRK-003",
    price: 784.88,
    image: "/products/tools/tool-storage-case.jpg",
    badge: "Premium",
    categoryId: "workshop-storage",
    categorySlug: "workshop-storage",
    description: "This Rugged Waterproof Tool Storage Case is designed to protect and organize your essential tools and equipment, perfect for professionals who need reliable storage solutions. Made from high-impact polymer with a watertight seal, it keeps contents safe from water, dust, and impact. Easy-to-open latches provide quick access, reinforced padlock holes add security, and the customizable foam interior holds tools firmly in place during transport.",
    keyBenefits: ["Waterproof and dustproof seal", "Customizable foam interior", "Secure latches with padlock holes"],
    usage: "Arrange the foam to fit your tools, close the latches and carry it anywhere the job goes.",
    features: ["Waterproof", "Foam Insert", "Lockable", "Portable"],
    inStock: true
  },

  // ===== POWER & ENERGY =====
  {
    id: "wind-turbine-generator",
    name: "Wind Turbine Generator",
    slug: "wind-turbine-generator",
    sku: "IET-NRG-001",
    price: 999.00,
    image: "/products/tools/wind-turbine-generator.jpg",
    badge: "Flagship",
    categoryId: "power-energy",
    categorySlug: "power-energy",
    description: "Maximize airflow in your industrial or commercial space with our high-efficiency aluminum crossflow fan - designed for reliability and optimal performance. A durable aluminum body endures demanding environments, the unique crossflow configuration delivers a steady, even stream of air for cooling and ventilation, and low-noise operation keeps noise-sensitive areas comfortable.",
    keyBenefits: ["Durable aluminum body", "Steady crossflow airflow", "Low-noise operation"],
    usage: "Mount it on the sturdy base, connect to standard voltage and enjoy steady, quiet airflow.",
    features: ["Aluminum", "Crossflow", "Low-Noise", "Easy Mount"],
    inStock: true
  },
];

export const categories = [
  {
    id: "measuring-detection",
    name: "Measuring & Detection",
    slug: "measuring-detection",
    description: "Range finders, stud finders, testers and meters for accurate, confident work",
    image: "/products/tools/clamp-meter-kit.jpg",
    productCount: 4
  },
  {
    id: "hand-tools",
    name: "Hand Tools",
    slug: "hand-tools",
    description: "Wrenches, drivers and precision sets forged for everyday grip and grit",
    image: "/products/tools/pipe-wrench.jpg",
    productCount: 3
  },
  {
    id: "power-tools",
    name: "Power Tools",
    slug: "power-tools",
    description: "Cordless drills, grinders and saws that bring serious muscle to any job",
    image: "/products/tools/cordless-drill-set.jpg",
    productCount: 3
  },
  {
    id: "workshop-storage",
    name: "Workshop & Storage",
    slug: "workshop-storage",
    description: "Benches, cases and bags that keep your gear organized and job-ready",
    image: "/products/tools/workbench-pegboard.jpg",
    productCount: 3
  },
  {
    id: "power-energy",
    name: "Power & Energy",
    slug: "power-energy",
    description: "Heavy-duty airflow and power equipment for shops and commercial spaces",
    image: "/products/tools/wind-turbine-generator.jpg",
    productCount: 1
  },
];

// ============================================
// FEATURES / WHY CHOOSE US
// ============================================
export const features = [
  { id: 1, title: 'Built Job-Site Tough', description: 'Every tool is picked for real-world durability under real workshop abuse' },
  { id: 2, title: 'Free USA Shipping', description: 'Free USPS Standard Shipping on every order, no minimum required' },
  { id: 3, title: '30-Day Returns', description: 'Not the right fit? Send it back within 30 days, no hassle' },
  { id: 4, title: 'Secure Checkout', description: 'Encrypted payments and privacy-first handling of your details' }
];

export const performanceBenefits = [
  { id: 1, title: 'Made to Work Hard', description: 'Hardened steel, sealed housings and motors engineered for the long haul' },
  { id: 2, title: 'Precision You Can Trust', description: 'Calibrated meters, laser guides and torque tools that hit the mark' },
  { id: 3, title: 'Pro & DIY Approved', description: 'Gear that earns its place in contractor rigs and home garages alike' },
  { id: 4, title: 'Straight, Honest Pricing', description: 'Fair prices on the hardware and tools you actually reach for' }
];

export const steps = [
  { id: 1, title: 'Browse', description: 'Explore our curated lineup of hardware, hand tools and power tools.' },
  { id: 2, title: 'Choose', description: 'Pick the measuring, cutting, driving or storage gear your job needs.' },
  { id: 3, title: 'Checkout', description: 'Complete your order with fast, secure and encrypted payment.' },
  { id: 4, title: 'Get to Work', description: 'Unbox, gear up and tackle the next project with confidence.' }
];
